import { Injectable } from '@angular/core';
import { LocalStorageManager } from '@examdojo/browser/local-storage';
import { AuthProvider } from './auth.model';

const LAST_USED_AUTH_METHOD_KEY = 'last_used_auth_method';

@Injectable({ providedIn: 'root' })
export class LastUsedAuthService {
  private readonly storageManager = new LocalStorageManager<{
    method: AuthProvider;
  }>(LAST_USED_AUTH_METHOD_KEY);

  getLastUsedMethod(): AuthProvider | null {
    return this.storageManager.getValue()?.method ?? null;
  }

  setLastUsedMethod(method: AuthProvider): void {
    this.storageManager.setValue({ method });
  }
}
